const billingHistoryStatus = {
  WAITING: 'AGUARDANDO_RECEBIMENTO',
  PAID: 'PAGO',
  OVERDUE: 'EM_ATRASO'
};

module.exports = billingHistoryStatus;
